package twist.mena.sports.shared.dto.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AutomationTestResultResponse(
    val id: String,
    @SerialName("run_id") val runId: String,
    @SerialName("suite_name") val suiteName: String,
    @SerialName("test_name") val testName: String,
    val status: String,
    @SerialName("duration_ms") val durationMs: Int,
    @SerialName("request_info") val requestInfo: String? = null,
    @SerialName("response_code") val responseCode: Int? = null,
    @SerialName("error_message") val errorMessage: String? = null,
    @SerialName("created_at_utc") val createdAtUtc: String
)
